import {
  GET_INVOICES,
  GET_INVOICES_FAIL,
  GET_INVOICES_SUCCESS,
  GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL_FAIL,
  GET_INVOICE_DETAIL_SUCCESS,
  SEND_INVOICE,
  SEND_INVOICE_FAIL,
  SEND_INVOICE_SUCCESS,
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_FAIL,
  GET_INVOICE_LIST_SUCCESS,
  GET_BULK_BILLINGS,
  GET_BULK_BILLINGS_SUCCESS,
  GET_BULK_BILLINGS_FAIL,
  SET_INVOICE_PAGINATION,
} from "./actionTypes";

export const getBulkBillings = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_BULK_BILLINGS,
  payload: { data, onError, onSuccess },
});

export const getBulkBillingsSuccess = data => ({
  type: GET_BULK_BILLINGS_SUCCESS,
  payload: data,
});

export const getBulkBillingsFail = error => ({
  type: GET_BULK_BILLINGS_FAIL,
  payload: error,
});

export const getInvoiceList = data => ({
  type: GET_INVOICE_LIST,
  payload: data,
});

export const getInvoiceListSuccess = data => ({
  type: GET_INVOICE_LIST_SUCCESS,
  payload: data,
});

export const getInvoiceListFail = error => ({
  type: GET_INVOICE_LIST_FAIL,
  payload: error,
});

export const sendInvoice = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_INVOICE,
  payload: { data, onError, onSuccess },
});

export const sendInvoiceSuccess = data => ({
  type: SEND_INVOICE_SUCCESS,
  payload: data,
});

export const sendInvoiceFail = error => ({
  type: SEND_INVOICE_FAIL,
  payload: error,
});

export const getInvoices = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_INVOICES,
  payload: { data, onSuccess, onError },
});

export const getInvoicesSuccess = invoices => ({
  type: GET_INVOICES_SUCCESS,
  payload: invoices,
});

export const getInvoicesFail = error => ({
  type: GET_INVOICES_FAIL,
  payload: error,
});

export const getInvoiceDetail = data => ({
  type: GET_INVOICE_DETAIL,
  payload: data,
});

export const getInvoiceDetailSuccess = data => ({
  type: GET_INVOICE_DETAIL_SUCCESS,
  payload: data,
});

export const getInvoiceDetailFail = error => ({
  type: GET_INVOICE_DETAIL_FAIL,
  payload: error,
});

export const setInvoicePagination = data => ({
  type: SET_INVOICE_PAGINATION,
  payload: data,
});
